import type { ICard } from "../../cardsSlice";

export const major19Card: ICard = {
    id: "major_19",
    arcana: "major",
    number: 19,
    suit: "major",
    court: "major",
    name: "Солнце",
    nameEn: "The Sun",
    keywords: ["Ясность", "Успех", "Радость"],
    symbolism: ["Солнце, излучающее свет", "Ребёнок на белом коне", "Флаг, подсолнухи, стена"],
    symbolismInterpretation:
      "Символ победы, жизни, открытости и радости. Раскрытие истины",
    archetype: "Архетип просветления, ясности, внутренняя радость ребёнка",
    psychology: "Принятие себя, внутренняя свобода, энергия жизни",
    upright: {
      personality: "Оптимизм, открытость, энергия",
      relationships: "Чистота, искренность, радость",
      work: "Успех, признание, результат усилий",
      spirituality: "Озарение, внутренний свет",
      examples: ["Ясность в отношениях", "Достижение цели", "Открытие себя"]
    },
    reversed: {
      meaning: "Неуверенность, скрытые мотивы, помутнение ясности",
      nuances: "Радость приглушена, успех возможен, но отложен"
    },
    associations: ["Свет", "Радость", "Открытость", "Детство"],
    combinations: ["С Влюблёнными — счастливый союз", "С Луной — выход из путаницы"],
    readingTips: ["Не забывать о светлой стороне", "Оценить, насколько вы честны с собой"],
    selfQuestions: ["Что наполняет меня светом?", "Где мне нужно проявиться открыто?"]
  };


